import { c as _c } from "react/compiler-runtime";
import { ReserveDetailContainerPropertiesTypes } from "@website/widget/reserve-gallery/reserve-gallery.types";
import range from "lodash-es/range";
import { useRouter } from "next/router";
import { useEffect } from "react";
export const useReserveGalleryDetailContainer = t0 => {
  const $ = _c(8);
  const {
    galleryLength,
    templateNumber
  } = t0;
  const router = useRouter();
  let t1;
  let t2;
  if ($[0] !== router.query.index) {
    t1 = () => {
      document.querySelector(`#gallery_image_${router.query.index}`)?.scrollIntoView();
    };
    t2 = [router.query.index];
    $[0] = router.query.index;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== galleryLength || $[4] !== templateNumber) {
    t3 = galleryLength > templateNumber ? range(0, galleryLength, templateNumber).map(index => ({
      index,
      rowCount: index + templateNumber < galleryLength ? templateNumber : galleryLength % templateNumber
    })) : [{
      index: 0,
      rowCount: galleryLength
    }];
    $[3] = galleryLength;
    $[4] = templateNumber;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const containerProperties = t3;
  let t4;
  if ($[6] !== containerProperties) {
    t4 = {
      containerProps: containerProperties
    };
    $[6] = containerProperties;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};